module.exports = __webpack_public_path__ + "810d46f049565b0e5a44ea54af134d2c.svg";